import { getUserFields } from "components/user/config";
import { getItemFromCollection } from "directus/src/operations";

export async function fetchInterviewDataforForm({ id }) {
  try {
    const query = {
      fields: [
        "id",
        "date_scheduled",
        "applicant.id",
        getUserFields("applicant.employee"),
        "applicant.experience",
        "applicant.is_selected",
        "title",
        "recording_url",
        "status",
        "client_feedback",
        "internal_feedback",
        "transcript",
        "is_cleared",
      ],
    };
    const response = await getItemFromCollection("opening_interviews", id, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
